import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled from 'react-emotion';
import config from '../../config/website';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Container from '../components/Container';
import ItemNews from '../components/ItemNews';
import LinkTagTopic from '../components/LinkTagTopic';

import FillBg from '../components/FillBg';

const Base = styled(Container)`
  padding-left: 3rem;
  padding-right: 3rem;
`;

const Team = ({
  pathContext: { team },
  data: {
    allMarkdownRemark: { edges, totalCount },
  },
}) => (
  <React.Fragment>
    <Helmet title={`@${team} | ${config.siteTitle}`} />
    <Header slim title={`@${team}`}>
      {totalCount} {totalCount === 1 ? 'Post' : 'Posts'}
      {totalCount === 1 ? '' : ''}
      <br />
    </Header>
    <Container>
      <FillBg>
        <LinkTagTopic />
        <Base>
          <br />
          {edges.map((edge, index) => (
            <ItemNews
              key={edge.node.frontmatter.title}
              title={edge.node.frontmatter.title}
              path={edge.node.fields.slug}
              date={edge.node.frontmatter.date}
              tags={edge.node.frontmatter.tags}
              topic={edge.node.frontmatter.topic}
              teams={edge.node.frontmatter.teams}
              timeToRead={edge.node.timeToRead}
              excerpt={edge.node.excerpt}
              data={index}
              cover={edge.node.frontmatter.cover}
            />
          ))}
        </Base>
      </FillBg>
    </Container>
    <Footer />
  </React.Fragment>
);

export default Team;

Team.propTypes = {
  pathContext: PropTypes.shape({
    team: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array.isRequired,
    }),
  }),
};

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query TeamPage($team: String) {
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { teams: { in: [$team] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          excerpt(pruneLength: 300)
          timeToRead
          frontmatter {
            title
            teams
            date(formatString: "MMM.DD.YYYY", locale: "en")
            topic
            tags
            cover {
              childImageSharp {
                sizes(maxWidth: 1920, quality: 90) {
                  ...GatsbyImageSharpSizes_withWebp
                }
                resize(width: 1200) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/team.jsx